(() => {
  'use strict';
  const root = document.getElementById('km-support');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const strings = JSON.parse(root.querySelector('[data-km-support-strings]').textContent);
  const t = key => strings[key] || key;
  const doc = document;
  const assistant = doc.getElementById('km-assistant');
  const inquiry = doc.getElementById('km-inquiry');
  const log = root.querySelector('[data-km-chat-log]');
  const chatForm = root.querySelector('[data-km-chat-form]');
  const product = doc.querySelector('[data-kp-current-product]');
  const normal = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const clean = (value, length = 160) => String(value || '').trim().slice(0, length);
  const context = {
    product: product?.dataset.productTitle || '',
    url: product ? new URL(product.dataset.productUrl, location.origin).href : '',
    code: product?.dataset.productMkb || '',
    productId: product?.dataset.productId || '', sku: product?.dataset.productSku || '',
    variantId: product?.querySelector('#kpmp-variant-id')?.value || '', price: product?.dataset.productPrice || '', search: '',
    vehicle: '', vin: '', service: '', reply: '', summary: '', name:'', email:'', phone:''
  };
  const history = [];
  const draftKey = 'km.inquiry.draft.v1';
  const chatKey = 'km.assistance.session.v1';
  const remember = () => {
    if (!history.some(item=>item.role==='user')) return;
    try {sessionStorage.setItem(chatKey,JSON.stringify({createdAt:Date.now(),history,context:{vehicle:context.vehicle,vin:context.vin,service:context.service,reply:context.reply,userCode:context.userCode||'',name:context.name,email:context.email,phone:context.phone}}));}catch(_){}
  };
  let lastFocus;
  const reference = () => 'KM-' + new Date().toISOString().slice(0,10).replaceAll('-','') + '-' + crypto.randomUUID().slice(0,8).toUpperCase();
  const snapshot = form => Object.fromEntries([...form.querySelectorAll('[data-kmi]')].map(input => [input.dataset.kmi, input.value]));
  const fill = form => {
    for (const [key, value] of Object.entries(context)) {
      const field = form.querySelector('[data-kmi="' + key + '"]');
      if (field && (field.type === 'hidden' || (value && (!field.value || field.value === field.dataset.kmiAutofill || (field.tagName === 'SELECT' && field.selectedIndex === 0))))) {
        field.value = value;
        field.dataset.kmiAutofill = value;
        field.dispatchEvent(new Event('change'));
      }
    }
    const ref = form.querySelector('[data-kmi="reference"]');
    if (!ref.value) ref.value = reference();
    const badge = form.querySelector('[data-kmi-context]');
    const offer=form.querySelector('[data-kmi="product"]')?.value || context.product;
    badge.textContent = offer ? t('product_label') + ': ' + offer : '';
    badge.hidden = !badge.textContent;
  };
  function close(dialog) { if (dialog?.open) dialog.close(); }
  function open(dialog, trigger) {
    if (!dialog) return;
    lastFocus = trigger || doc.activeElement;
    doc.querySelectorAll('.km-support-dialog[open]').forEach(other => { if (other !== dialog) close(other); });
    doc.querySelectorAll('.k9-menu[open]').forEach(menu => menu.removeAttribute('open'));
    if (!dialog.open) dialog.showModal();
    doc.body.classList.add('km-support-open');
  }
  function append(role, text) {
    const p = doc.createElement('p');
    p.className = 'km-chat-message km-chat-message--' + role;
    const name = doc.createElement('strong');
    name.textContent = role === 'user' ? t('you') : t('assistant_title');
    const content = doc.createElement('span');
    content.textContent = text;
    p.append(name, content); log.append(p);
    history.push({role, text: clean(text, 1800)});
    if (history.length > 30) { history.shift(); log.firstElementChild?.remove(); }
    log.scrollTop = log.scrollHeight;
    remember();
  }
  function capture(text) {
    const upper = text.toUpperCase();
    const email=text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
    if(email)context.email=email[0];
    const phone=text.match(/(?:telefon|handy|nummer|whatsapp)\s*[:=]?\s*(\+?\d[\d ()/.-]{6,24}\d)/i);
    if(phone)context.phone=clean(phone[1],40);
    const name=text.match(/(?:ich heiße|ich heisse|mein name ist)\s+([\p{L}][\p{L}'’\-]*(?:\s+[\p{L}][\p{L}'’\-]*){0,3})/iu);
    if(name)context.name=clean(name[1],100);
    const vin = upper.match(/\b[A-HJ-NPR-Z0-9]{17}\b/);
    if (vin) context.vin = vin[0];
    const code = upper.match(/\b(?:[BMN][3456]\d[AD]\d\d[A-Z0-9]*|OM\s?\d{3}(?:\.\d{3})?|[CDB][A-Z]{3})\b/);
    if (code) {context.code = code[0].replace(/\s/g,'');context.userCode=context.code;}
    const vehicle = text.match(/\b(?:BMW|Audi|Volkswagen|VW|Mercedes(?:-Benz)?|Seat|Skoda|Škoda|Cupra|Mini)\s+[a-zA-Z0-9 .-]{1,45}/i);
    if (vehicle) context.vehicle = clean(vehicle[0], 100);
    const n = normal(text);
    if (/\b(nur motor|ohne einbau)\b/.test(n)) context.service = t('service_engine');
    else if (/einbau|ausbau/.test(n)) context.service = t('service_install');
    else if (/reparatur|instandsetzung/.test(n)) context.service = t('service_repair');
    if (/ruckruf|anruf|telefon/.test(n)) context.reply = 'Telefon';
    if (/whatsapp/.test(n)) context.reply = 'WhatsApp';
    if (/e-?mail/.test(n)) context.reply = 'E-Mail';
  }
  function answer(text) {
    const n = normal(text), replies = [];
    const rules = [
      ['scope', /lieferumfang|anbauteil|injektor|turbo|hochdruck|enthalten/],
      ['exchange', /altteil|kaution|austausch|ruckgabe/],
      ['delivery', /liefer|versand|transport/],
      ['install', /einbau|ausbau|werkstatt|montage/],
      ['warranty', /gewahr|garantie/],
      ['pickup', /abhol|offnungs|uhr|adresse|standort/],
      ['price', /preis|kostet|kosten|rabatt|gunstig/],
      ['availability', /bestand|verfugb|sofort|morgen|termin|lieferzeit/],
      ['fitment', /passt|passend|fin|vin|fahrgestell|kompatib|welche[rn]? motor/]
    ];
    for (const [topic, pattern] of rules) if (pattern.test(n)) replies.push((topic==='price' && product?.dataset.productPrice ? context.product+': '+product.dataset.productPrice+'\n\n' : '')+t(topic + '_answer'));
    if (!replies.length) return context.vehicle || context.code || context.vin ? t('known_vehicle') : t('fallback');
    return replies.slice(0,3).join('\n\n');
  }
  function message(form) {
    const data = form ? {...context, ...snapshot(form)} : context;
    const lines = ['Hallo KM MOTOREN,', '', data.body || 'ich möchte mein Anliegen persönlich prüfen lassen.'];
    for (const [key,label] of [['reference','reference_label'],['product','product_label'],['vehicle','vehicle'],['code','code'],['vin','vin'],['service','service'],['reply','reply']]) {
      if (data[key]) lines.push(t(label) + ': ' + data[key]);
    }
    for (const [key,label] of [['productId','product_id_label'],['sku','sku_label'],['price','price_label'],['search','search_context'],['year','year_label'],['mileage','mileage_label'],['engine','engine_label'],['drive','drive_label'],['hsn','hsn_label'],['tsn','tsn_label'],['symptoms','symptoms_label'],['previousWork','work_label'],['transport','transport_label'],['preferredDate','date_label']]) if(data[key]) lines.push(t(label)+': '+data[key]);
    if (data.url) lines.push(data.url);
    if (data.name) lines.push('Name: ' + data.name);
    if (data.email) lines.push('E-Mail: ' + data.email);
    if (data.phone) lines.push('Telefon: ' + data.phone);
    if (history.length > 1) lines.push('', 'Gespräch:', ...history.slice(-8).map(item => (item.role === 'user' ? t('you') : t('assistant_title')) + ': ' + item.text));
    return lines.join('\n').slice(0,7000);
  }
  function handoff(trigger) {
    context.summary = history.map(item => (item.role === 'user' ? t('you') : t('assistant_title')) + ': ' + item.text).join('\n').slice(-8000);
    const concern = history.filter(item => item.role === 'user').map(item => item.text).join('\n');
    if (concern) context.body = concern.slice(0,4000);
    const form=doc.querySelector('.km-inquiry-form');
    if (!form) {
      const destination=root.dataset.requestUrl || '/pages/reparaturanfrage';
      try {sessionStorage.setItem(draftKey,JSON.stringify({page:new URL(destination,location.origin).pathname,createdAt:Date.now(),values:{...context,reference:reference()}}));}catch(_){}
      location.assign(destination);
      return;
    }
    fill(form);
    close(assistant);
    if (inquiry) open(inquiry,trigger);
    else {
      form?.scrollIntoView({block:'start',behavior:'instant'});
      form?.querySelector('input:not([type="hidden"])')?.focus();
    }
  }
  function reset() {
    history.length = 0; log.replaceChildren();
    for (const key of ['vehicle','vin','service','reply','summary','body','userCode','name','email','phone']) context[key] = '';
    context.code = product?.dataset.productMkb || '';
    doc.querySelectorAll('.km-inquiry-form [data-kmi]').forEach(field => {
      if (field.dataset.kmi === 'summary' || (field.dataset.kmiAutofill && field.value === field.dataset.kmiAutofill && !['product','url','code'].includes(field.dataset.kmi))) {
        field.value = field.tagName === 'SELECT' ? field.options[0].value : '';
        delete field.dataset.kmiAutofill;
        field.dispatchEvent(new Event('change'));
      }
    });
    try { sessionStorage.removeItem(draftKey);sessionStorage.removeItem(chatKey); } catch (_) {}
    append('assistant',t('greeting'));
  }
  doc.querySelectorAll('.km-support-dialog').forEach(dialog => {
    dialog.addEventListener('close',() => {
      if (!doc.querySelector('.km-support-dialog[open]')) doc.body.classList.remove('km-support-open');
      if (lastFocus?.isConnected) lastFocus.focus();
    });
    dialog.addEventListener('click',event => { if (event.target === dialog) { const rect=dialog.getBoundingClientRect(); if (event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) close(dialog); } });
  });
  doc.addEventListener('click',event => {
    const target = event.target.closest('button,a'); if (!target) return;
    if (target.matches('[data-km-assistant-open]')) {event.preventDefault();open(assistant,target);}
    if (target.matches('[data-km-dialog-close]')) close(target.closest('dialog'));
    if (target.matches('[data-km-inquiry-open]')) {event.preventDefault();if(target.dataset.kmService) context.service=t({install:'service_install',repair:'service_repair',engine:'service_engine'}[target.dataset.kmService]||'service_unknown');if(product){context.product=product.dataset.productTitle||'';const url=new URL(product.dataset.productUrl,location.origin);const selected=product.querySelector('#kpmp-variant-id');if(selected?.value)url.searchParams.set('variant',selected.value);context.url=url.href;context.productId=product.dataset.productId||'';context.variantId=selected?.value||'';context.sku=product.dataset.productSku||'';context.price=product.dataset.productPrice||'';context.code=product.dataset.productMkb||'';if(!context.body)context.body=t('product_request');}if(target.dataset.kmSearch){context.search=clean(target.dataset.kmSearch);if(!context.body)context.body=t('search_context')+': '+context.search;}handoff(target);}
    if (target.matches('[data-km-chat-clear]')) reset();
    if (target.matches('[data-km-topic]')) {
      append('user',t('topic_' + target.dataset.kmTopic));
      append('assistant',t(target.dataset.kmTopic + '_answer'));
    }
    if (target.matches('[data-km-wa-context]')) target.href='https://wa.me/'+root.dataset.phone.replace(/\D/g,'')+'?text='+encodeURIComponent(message(target.closest('.km-inquiry-form')));
  });
  chatForm.addEventListener('submit',event => {
    event.preventDefault();
    const text=clean(chatForm.elements.message.value,1000); if (!text) return;
    capture(text); append('user',text); chatForm.reset(); append('assistant',answer(text));
    if (context.code && !context.vin) {
      const link=doc.createElement('a');link.className='km-chat-catalog';
      link.href='/search?type=product&q='+encodeURIComponent(context.code);link.textContent=t('search_offers')+' '+context.code;
      log.lastElementChild.append(link);
    }
  });
  doc.addEventListener('km:inquiry-context',event => {
    const values=event.detail || {};
    for (const key of ['vehicle','code','vin','service','body','search','hsn','tsn','year','engine']) if (typeof values[key]==='string') context[key]=clean(values[key],key==='body'?4000:160);
    if (values.open) handoff(doc.activeElement);
  });
  const currentForms=[...doc.querySelectorAll('.km-inquiry-form')];
  currentForms.forEach(form => {
    form.noValidate = true;
    fill(form);
    let saved;
    try {saved=JSON.parse(sessionStorage.getItem(draftKey)||'null');} catch (_) {}
    if (saved?.page===location.pathname && saved.createdAt>Date.now()-1800000 && saved.createdAt<=Date.now() && saved.values) {
      for (const input of form.querySelectorAll('[data-kmi]')) if ((!input.value || input.tagName==='SELECT' || input.dataset.kmi==='reference') && typeof saved.values[input.dataset.kmi]==='string' && (input.tagName!=='SELECT' || [...input.options].some(option=>option.value===saved.values[input.dataset.kmi]))) input.value=saved.values[input.dataset.kmi];
      for(const key of ['product','url','productId','variantId','sku','price','search','vehicle','code','vin','service','reply','summary','body','year','engine','hsn','tsn','drive','mileage','symptoms','previousWork','transport','preferredDate'])if(!context[key]&&typeof saved.values[key]==='string')context[key]=saved.values[key];
    }
    try {
      const damage=JSON.parse(sessionStorage.getItem('kp.v4.repairDraft')||'null');
      if(damage&&typeof damage==='object'){
        const values={vehicle:[damage.brand,damage.model,damage.year,damage.engine].filter(Boolean).join(' '),code:damage.mkb||'',service:t('service_repair'),body:[damage.symptoms?.length?'Symptome: '+damage.symptoms.join(', '):'',damage.errors?'Fehlercodes / Befund: '+damage.errors:'',damage.note||'',damage.km?'Kilometerstand: '+damage.km:'',damage.drive?'Fahrbereit: '+damage.drive:'',damage.opened?'Motor geöffnet: '+damage.opened:''].filter(Boolean).join('\n')};
        for(const [key,value] of Object.entries(values)){const field=form.querySelector('[data-kmi="'+key+'"]');if(field&&(!field.value||field.tagName==='SELECT'))field.value=clean(value,key==='body'?4000:160);}
        sessionStorage.removeItem('kp.v4.repairDraft');
      }
    }catch(_){}
    fill(form);
    const params=new URLSearchParams(location.search);
    const mappings={vehicle:['marke','modell'],code:['mkb'],year:['baujahr'],hsn:['hsn'],tsn:['tsn'],search:['q'],body:['probleme','beschreibung','befund']};
    for (const [key,names] of Object.entries(mappings)) { const field=form.querySelector('[data-kmi="'+key+'"]');const value=names.map(name=>params.get(name)||'').filter(Boolean).join(' ');if(value&&!field.value)field.value=clean(value,key==='body'?4000:160); }
    if(params.get('leistung')==='einbau'){context.service=t('service_install');fill(form);}
    const searchTerm=form.querySelector('[data-kmi="search"]')?.value;if(searchTerm&&!form.querySelector('[data-kmi="body"]').value)form.querySelector('[data-kmi="body"]').value=t('search_context')+': '+searchTerm;
    const reply=form.querySelector('[data-kmi="reply"]'), phone=form.querySelector('[data-kmi="phone"]');
    const sync=()=>{phone.required=['Telefon','WhatsApp'].includes(reply.value);phone.setCustomValidity('');};reply.addEventListener('change',sync);sync();
    form.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},true);
    form.addEventListener('input',event=>{event.target.setCustomValidity?.('');if(event.target.dataset.kmi==='vin')event.target.value=event.target.value.toUpperCase().replace(/[\s-]/g,'');});
    let submitting=false;
    form.addEventListener('submit',event=>{
      if(submitting){event.preventDefault();return;}
      if (!navigator.onLine) {event.preventDefault();form.querySelector('[data-kmi-status]').textContent=t('send_failed');return;}
      const vin=form.querySelector('[data-kmi="vin"]');vin.value=vin.value.toUpperCase().replace(/[\s-]/g,'');
      for (const field of form.querySelectorAll('input,select,textarea')) {
        field.setCustomValidity('');
        if (field.required && !field.value.trim()) field.setCustomValidity(t('field_required'));
        else if (field.type==='email' && field.validity.typeMismatch) field.setCustomValidity(t('email_invalid'));
        else if (field===vin && field.value && !/^[A-HJ-NPR-Z0-9]{17}$/.test(field.value)) field.setCustomValidity(t('vin_invalid'));
      }
      if (!vin.validity.valid) vin.closest('details').open=true;
      form.querySelectorAll('details').forEach(details=>{if([...details.querySelectorAll('input,select,textarea')].some(field=>!field.validity.valid))details.open=true;});
      if (!form.reportValidity()) {event.preventDefault();return;}
      try {sessionStorage.setItem(draftKey,JSON.stringify({page:location.pathname,createdAt:Date.now(),values:snapshot(form)}));}catch(_){}
      submitting=true;const submit=form.querySelector('[type=submit]');submit.disabled=true;
      form.querySelector('[data-kmi-status]').textContent=t('sending');
      window.setTimeout(()=>{if(form.isConnected&&!form.querySelector('[data-km-inquiry-success]')){submitting=false;submit.disabled=false;form.querySelector('[data-kmi-status]').textContent=t('send_unconfirmed');}},25000);
    });
    if(form.querySelector('[data-km-inquiry-error]')&&form.closest('dialog'))open(form.closest('dialog'));
    if (form.querySelector('[data-km-inquiry-success]')) {try {sessionStorage.removeItem(draftKey);sessionStorage.removeItem(chatKey);}catch(_){}if(form.closest('dialog'))open(form.closest('dialog'));}
  });
  const bottomSpace=()=>{
    const height=matchMedia('(max-width:900px)').matches?Math.max(0,...[...doc.querySelectorAll('.km-contact-bar,.km-sticky-buy')].map(bar=>bar.getBoundingClientRect().height)):0;
    doc.body.style.setProperty('--km-contact-height',Math.ceil(height)+'px');
  };
  const viewport=()=>{
    const v=window.visualViewport, keyboard=!!v&&window.innerHeight-v.height>160;
    doc.documentElement.classList.toggle('km-keyboard-open',keyboard);
    doc.documentElement.style.setProperty('--km-visible-height',(v?.height||window.innerHeight)+'px');
    bottomSpace();
  };
  window.visualViewport?.addEventListener('resize',viewport);window.addEventListener('resize',viewport);viewport();
  const overlays=()=>{
    const panel=doc.querySelector('dialog[open],.kpp-overlay[aria-hidden="false"],.k9-menu[open],[data-km-filters].is-open,[data-kpv6-privacy-modal].is-open');
    const panelOpen=!!panel&&panel.getClientRects().length>0;
    if(doc.body.classList.contains('km-ui-overlay-open')!==panelOpen)doc.body.classList.toggle('km-ui-overlay-open',panelOpen);
    const cookie=doc.querySelector('[data-kpv6-cookie].is-visible:not([hidden]),[data-kpv6-privacy-modal].is-open,#shopify-pc__banner:not([hidden])');
    const visible=!!cookie&&cookie.getClientRects().length>0;
    if (doc.body.classList.contains('km-consent-open') !== visible) doc.body.classList.toggle('km-consent-open',visible);
  };
  if('ResizeObserver' in window){const observer=new ResizeObserver(bottomSpace);doc.querySelectorAll('.km-contact-bar,.km-sticky-buy').forEach(bar=>observer.observe(bar));}
  new MutationObserver(()=>{overlays();bottomSpace();}).observe(doc.body,{subtree:true,attributes:true,attributeFilter:['class','hidden','open','aria-hidden'],childList:true});
  const footer=doc.querySelector('.k9-footer');
  if(footer && 'IntersectionObserver' in window) new IntersectionObserver(entries=>{
    const visible=entries.some(entry=>entry.isIntersecting);
    if(doc.body.classList.contains('km-footer-visible')!==visible) doc.body.classList.toggle('km-footer-visible',visible);
  }).observe(footer);
  overlays();bottomSpace();
  let previous;
  try {previous=JSON.parse(sessionStorage.getItem(chatKey)||'null');}catch(_){}
  if(previous?.createdAt>Date.now()-1800000&&previous.createdAt<=Date.now()&&Array.isArray(previous.history)){
    for(const key of ['vehicle','vin','service','reply','userCode','name','email','phone'])if(typeof previous.context?.[key]==='string')context[key]=clean(previous.context[key]);
    if(context.userCode)context.code=context.userCode;
    for(const item of previous.history.slice(-30))if(['assistant','user'].includes(item.role)&&typeof item.text==='string')append(item.role,clean(item.text,1800));
  }
  if(!history.length)append('assistant',t('greeting'));
  const expire=()=>{for(const key of [draftKey,chatKey])try{const value=JSON.parse(sessionStorage.getItem(key)||'null');if(value&&(value.createdAt<=Date.now()-1800000||value.createdAt>Date.now()))sessionStorage.removeItem(key);}catch(_){}};
  expire();window.setInterval(expire,60000);
})();
